module.exports = __webpack_public_path__ + "img/AutomaticProtection.4cdcabb.svg";